import { SignalDispatcher, SimpleEventDispatcher, EventDispatcher } from "strongly-typed-events";
import { ControladorBase } from '@/components/a-interfaz/a-controlador';
import { isNumber, isString } from 'util';
import { Utiles } from '@/__env/pluggins/event-bus';
import router from '@/__env/router.index';
import { Articulo } from '@/__env/lib/Articulos';

export class ControladorInterfaz extends ControladorBase
{
    constructor()
    {
        super();
        this.Vista.Titulo = 'Ventas';
        this.Vista.Opciones.push(
            { Tipo: 'opcion', Icono: 'view-list', Modo: 'resumen', Titulo: 'Resumen' },
            { Tipo: 'opcion', Icono: 'package', Modo: 'imagenes', Titulo: 'Imagenes' },
        );
    }

    public Articulo: Articulo;
    async Iniciar( ped: Articulo | string )
    {
        this.Articulo = null;
        this.Vista.Modo = '';
        this.Vista.Estado = 'cargando';
        if ( ped instanceof Articulo )
        {
            this.Articulo = ped;
        } else if ( isString( ped ) )
        {
            this.Articulo = await Articulo.create( ped );
        }

        if ( !this.Articulo || !this.Articulo.Existe )
        {
            Utiles.Notificaciones.Error( '¡Artículo no existe!' );
            router.replace( '/productos' );
            return;
        }

        this.Vista.Titulo = 'Artículo ' + this.Articulo.Id;

        this.Vista.Modo = 'resumen';

        await this.Articulo.CargarTitulo();
        await this.Articulo.CargarMarca();
        await this.Articulo.CargarSector();

        this.Vista.Estado = 'iniciado';

    }


    async Recargar()
    {
        await this.Iniciar( this.Articulo.Id );
    }

}

export const Controlador = new ControladorInterfaz();


